if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        cartDrawer: ".f-cart-drawer__inner",
        leftToSpend: "[data-left-to-spend]",
        cartGoalTitle: ".f-cartgoal__title",
      };

      this.confettiShow = false;
      this.goalDone = false;
      this.goal =
        Number(this.dataset.cartGoal) *
          Number(window.Shopify.currency.rate || 1) || 0;
      this.money_format = window.FoxThemeSettings.money_format;
      this.enableConfetti = this.dataset.enableConfetti === "true";
      this.refreshTimer = null;
    }

    connectedCallback() {
      // Initial value from Liquid (cart.total_price = subtotal after discounts)
      this.updateCartGoal(Number(this.dataset.cartTotal));

      // Refresh on theme cart updates (add, remove, quantity change)
      if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== "undefined") {
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.scheduleRefresh();
        });
      }

      // Also refresh whenever the drawer's subtotal/discount area changes
      // (catches discount codes applied or removed in the drawer)
      const watchRoot =
        document.getElementById("cart-drawer") ||
        this.closest(".cart-template") ||
        document.body;

      this.observer = new MutationObserver((mutations) => {
        const outsideBar = mutations.some((m) => !this.contains(m.target));
        if (outsideBar) this.scheduleRefresh();
      });
      this.observer.observe(watchRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      this.confettiShow = this.goalDone;
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    scheduleRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refreshFromCart(), 250);
    }

    async refreshFromCart() {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        const res = await fetch(root + "cart.js", { cache: "no-store" });
        const cart = await res.json();
        // total_price = subtotal after all discounts (what the drawer shows as Subtotal)
        if (Number(this.dataset.lastTotal) !== cart.total_price) {
          this.dataset.lastTotal = cart.total_price;
          this.updateCartGoal(cart.total_price);
        }
      } catch (e) {
        console.error("Cart goal refresh failed", e);
      }
    }

    updateCartGoal(state) {
      if (state > 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }

      this.cartTotal = state / 100;
      this.goalLeft = this.goal - this.cartTotal;
      this.goalDone = this.goalLeft <= 0;

      this.percent = (this.cartTotal * 100) / this.goal;
      if (this.percent >= 100) this.percent = 100;

      if (this.cartTotal >= this.goal) {
        this.style.setProperty("--progress", `${this.percent}%`);
        this.classList.add("f-cartgoal--done", "shakeY");
        this.dataset.total = this.cartTotal;
      } else {
        let spend = (this.goal - this.cartTotal) * 100;
        this.querySelector(this.selectors.leftToSpend).innerHTML = formatMoney(
          spend,
          this.money_format
        );
        this.classList.remove("f-cartgoal--done", "shakeY");
        this.style.setProperty("--progress", `${this.percent}%`);
        this.dataset.total = this.cartTotal;
      }

      if (this.goalLeft <= 0 && this.enableConfetti) {
        this.showConfetti();
      } else {
        this.confettiShow = false;
      }
    }

    showConfetti() {
      const cartDrawer = this.closest(this.selectors.cartDrawer);
      const cartTemplate = this.closest(".cart-template");

      if (!this.confettiShow && (cartDrawer || cartTemplate)) {
        setTimeout(() => {
          if (cartDrawer) {
            new window.FoxTheme.Confetti(cartDrawer);
          }
          if (cartTemplate) {
            new window.FoxTheme.Confetti(document.body);
          }
          this.confettiShow = true;
        }, 800);
      }
    }
  }

  customElements.define("f-cart-goal", FCartGoal);
}